
<script setup>

  import { ref, computed, watch, onMounted } from 'vue';

  import { useRoute } from 'vue-router';

  import { PlayCircleIcon } from '@heroicons/vue/24/outline';

  import { seenPlayerDialog } from '../stores/activity-3.js';

  import VideoPlayerDialog from '../dialogs/video-player.vue';

  import videoPath from '../video/activity-3.mp4';

  import captionsPath from '../video/activity-3-captions.vtt';

  import descriptionsPath from '../video/activity-3-descriptions.vtt';

  import subheaderBackgroundPath from '../images/subheader-background.jpg';

  const props = defineProps( { header: Object, buttons: Object } );

  const route = useRoute();

  const playerDialog = ref( null );
  
  const part = computed( () => ( route.path.match( /\/part\/(\d+)/ ) ?? [] )[ 1 ] );
  
  const subtitle = computed( () => part.value ? `Part ${ part.value }: ${ ( [ 'Oral Histories', 'Creative Writing' ] )[ part.value - 1 ] }` : null );

  onMounted( () =>

    watch( () => route.path, path => {

      seenPlayerDialog.value = false;

      playerDialog.value.close();

      if ( path === '/activity/3/intro' )
      
        playerDialog.value.open().then( () => seenPlayerDialog.value = true );

    }, { immediate: true } ) );

</script>

<template>

  <section>
    
    <Teleport :to="header" v-if="subtitle">

      <div class="flex bg-cover" :style="{ 'background-image': `url( ${ subheaderBackgroundPath } )` }">

        <div class="grow ml-6 lg:ml-20 mr-6 py-2 md:py-3">

          <h2>

            <div class="text-sm tracking-narrow font-semibold uppercase">Activity 3: The Essence of Life at Lewis</div>

            <div class="text-2xl md:text-3xl font-heading uppercase">{{ subtitle }}</div>

          </h2>

        </div>

      </div>

    </Teleport>

    <div class="grid">

      <RouterView v-slot="{ Component }">
    
        <Transition

          enter-from-class="opacity-0"

          leave-to-class="opacity-0"

          enter-active-class="transition duration-300"

          leave-active-class="transition duration-300">

          <component :is="Component" class="row-start-1 col-start-1 min-h-view" />
          
        </Transition>
        
      </RouterView>

    </div>

    <VideoPlayerDialog
    
      ref="playerDialog" eyebrow="Activity 3" heading="The Essence of Life at Lewis"
    
      :src="videoPath" :tracks="[
        
        { default: true, src: captionsPath, kind: 'captions', label: 'English', srcLang: 'en' },

        { src: descriptionsPath, kind: 'descriptions', label: 'English', srcLang: 'en' }
        
      ]" />

    <Teleport :to="buttons" v-if="buttons">

      <button type="button" class="flex items-center px-5 gap-2 h-full hover:underline focus-visible:underline" @click="playerDialog.open()">
        
        <PlayCircleIcon class="w-5" />

        <span class="text-sm">Replay Video</span>
      
      </button>

    </Teleport>

  </section>

</template>
